import { useSelector } from "react-redux";
import VideoStreamingChannelCard from "../../schoolAdminPortal/Video Streaming/VideoStreamingChannelCard";
import { useEffect } from "react";
import { setAvsChannelList } from "../../../Redux/Actions/VideoStreamingActions";
import { useDispatch } from "react-redux";
import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import Container from "@material-ui/core/Container";
import SuperAdminDashboard from "../superAdminDashboard";

const IvsChannelList = () => {
  const videoStreamAvsChannelList = useSelector(
    (state) => state?.videoStreamData?.videoStreamAvsChannelList
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setAvsChannelList(dispatch);
  }, []);

  return (
    <>
      <div className="content-layout add-sectionn p-0 position-relative">
        <SuperAdminDashboard />
        <ContentLayoutDetailsHeader
          label="IVS Channels"
          name="Angles"
          navigationLink="/schooladmindata"
          iconList={[]}
        />
        <Container className="mg-top-70 mg-bottom-10">
          <div className="video-streaming-channel-grid">
            {videoStreamAvsChannelList?.map((item, index) => (
              <VideoStreamingChannelCard
                channelName={item?.channelName}
                channelState={item?.assigned}
                index={index}
              />
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};

export default IvsChannelList;
